export default {
  AE: 'WLTP',
  AU: 'WLTP',
  AT: 'WLTP',
  BE: 'WLTP',
  CA: 'EPA',
  CH: 'WLTP',
  DE: 'WLTP',
  DK: 'WLTP',
  ES: 'WLTP',
  EU: 'WLTP',
  FI: 'WLTP',
  FR: 'WLTP',
  GB: 'WLTP',
  HK: 'WLTP',
  IE: 'WLTP',
  IT: 'WLTP',
  JP: 'WLTP',
  JO: 'WLTP',
  LU: 'WLTP',
  MO: 'WLTP',
  MX: 'EPA',
  NL: 'WLTP',
  NO: 'WLTP',
  NZ: 'WLTP',
  PT: 'WLTP',
  SE: 'WLTP',
  TW: 'WLTP',
  US: 'EPA',
};
